module.exports = __webpack_public_path__ + "img/Entertainment.bd11ecd9.jpg";